// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"890123b6","470":"5134a294","769":"e3846a17","924":"b5747365"}[chunkId] + ".chunk.css";
};